
const NotFoundInternalPage = () => <div />;

export default NotFoundInternalPage;
